import { IconPlus } from '@tabler/icons-react-native';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { Pressable } from 'react-native';

const theme = createDSTheme();

interface CreateListingBannerButtonProps {
  label: string;
  onPress: () => void;
}

export function CreateListingBannerButton({ label, onPress }: Readonly<CreateListingBannerButtonProps>) {
  return (
    <Pressable onPress={onPress}>
      <Row
        alignItems="center"
        backgroundColor="surface.primary"
        borderRadius="radius.lg"
        justifyContent="space-between"
        padding="spacing.general.x6"
      >
        <Row alignItems="center" flex={1} gap="spacing.general.x4">
          <Text fontSize={23} fontWeight="700">
            👋
          </Text>
          <Text color="text.primary" fontWeight="700" variant="bodyLarge">
            {label}
          </Text>
        </Row>
        <IconPlus strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['text.primary']} />
      </Row>
    </Pressable>
  );
}
